import { useQuery } from '@apollo/client/react';
import { useCountry } from '../../components/CountrySelector';
import { GET_RETURN_SUMMARY_QUERY } from './returnSummary.rest';

type UseReturnSummaryArgs = {
  shipmentNumber?: string;
  orderNumber?: string;
};

export const useReturnSummary = ({ shipmentNumber, orderNumber }: UseReturnSummaryArgs) => {
  const {
    country: { alpha2Code: countryCode }
  } = useCountry();

  const { data, loading, error } = useQuery(GET_RETURN_SUMMARY_QUERY, {
    variables: { shipmentNumber, orderNumber, countryCode }
  });

  return {
    returnSummary: data?.getReturnSummary.data[0],
    loading,
    error
  };
};
